import types from './types'
import axios from 'axios'

export default {

    reset ({ commit }) {
        commit(types.RESET)
    },

    async createTask ({commit}, {item}) {
        commit(types.CREATE_ITEM.REQUEST)
        try {
            const result = await axios.post(`/api/task`, item)
            commit(types.CREATE_ITEM.SUCCESS, result)
            return result
        } catch (e) {
            commit(types.CREATE_ITEM.FAILURE)
        }
    },

    async updateTask ({commit}, {id, item}) {
        commit(types.UPDATE_ITEM.REQUEST)
        try {
            commit(types.UPDATE_ITEM.SUCCESS, await axios.put(`/api/task/${id}`, item))
        } catch (e) {
            commit(types.UPDATE_ITEM.FAILURE)
        }
    },

    async removeTask ({commit}, {id}) {
        commit(types.REMOVE_ITEM.REQUEST)
        try {
            commit(types.REMOVE_ITEM.SUCCESS, await axios.delete(`/api/task/${id}`, {}))
        } catch (e) {
            commit(types.REMOVE_ITEM.FAILURE)
        }
    },

    async getTaskDetails ({ commit }, { id }) {
        commit(types.GET_ITEM.REQUEST, { id })
        try {
            commit(types.GET_ITEM.SUCCESS, await axios.get(`/api/task/${id}`, {}))
        } catch (err) {
            commit(types.GET_ITEM.FAILURE)
        } finally {
        }
    },

    async getUsers ({ commit }, { l, search }) {
        commit(types.GET_USER.REQUEST, { l, search })
        try {
            const result = await axios.get(`/api/task/users`, { params: { l: l, search: search } })
            commit(types.GET_USER.SUCCESS, result)
        } catch (err) {
            commit(types.GET_USER.FAILURE)
        }
    },

    async getTeams ({ commit }, { l, search }) {
        commit(types.GET_TEAM.REQUEST, { l, search })
        try {
            const result = await axios.get(`/api/task/teams`, { params: { l: l, search: search } })
            commit(types.GET_TEAM.SUCCESS, result)
        } catch (err) {
            commit(types.GET_TEAM.FAILURE)
        }
    },

    async setCompleted ({commit}, {id, completed}) {
        commit(types.SET_COMPLETED.REQUEST)
        try {
            commit(types.SET_COMPLETED.SUCCESS, await axios.put(`/api/task/${id}/${completed}`), {})
        } catch (e) {
            commit(types.SET_COMPLETED.FAILURE)
        }
    },
}
